import { render, staticRenderFns } from "./JSON.vue?vue&type=template&id=65b556d6&scoped=true"
import script from "./JSON.vue?vue&type=script&lang=js"
export * from "./JSON.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b556d6",
  null
  
)

export default component.exports